/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InventorySplitPathParams, InventorySplitRequest, InventorySplitResponse } from '../types/InventorySplit'

/**
 * POST /:organisation/inventory/:item/split
 * @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::split
 */
export async function inventorySplit(
	organisation: InventorySplitPathParams['organisation'],
	item: InventorySplitPathParams['item'],
	data: InventorySplitRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InventorySplitResponse>> {
	return axiosInstance.post(`/${organisation}/inventory/${item}/split`, data, config)
}
